import PropTypes from "prop-types";
import React, { Fragment } from "react";
import styles from "./feeds-seo-care-information.css";

function FeedsSeoCareInformation({ careInformation }) {
    return (
        <div className={styles.careInformation}>
            <h3>{careInformation.title}</h3>
            <dl>
                {careInformation.items.map((item, index) => {
                    return (
                        <Fragment key={`caretitle${index}`}>
                            <dt className={styles.careInformationTitle}>{item.title}</dt>
                            <dd
                                className={styles.careInformationBody}
                                dangerouslySetInnerHTML={{ __html: item.body }}
                            ></dd>
                        </Fragment>
                    );
                })}
            </dl>
        </div>
    );
}

FeedsSeoCareInformation.propTypes = {
    careInformation: PropTypes.object,
};

export default FeedsSeoCareInformation;
